import { DataDogSampleRate } from './types'

export const DEFAULT_SAMPLE_RATE: DataDogSampleRate = 100
